<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>
    

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ objEdicao.id }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Ano/Mês</label>
                <div class="field-label field-label-center">{{ objEdicao.anomes }}</div>
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center">{{ objEdicao.protocolo }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Responsável</label>
                <div class="field-label">{{ globalStore.nmusuario }}</div>
            </div>
        </div>


        <div v-if="!modoItens">
            <!-- <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <textarea v-model="objEdicao.informacoes" maxlength="1000" rows="5" style="resize: none;"/>
                </div>
            </div> -->

            <div class="row-end">
                <button v-if="objEdicao.anomes != 0" class="btn-confirm" @click="salvarCabecalho">Iniciar Preenchimento</button>
                <button @click="closeForm">Retornar</button>
            </div>
        </div>
        
    
    
        <div v-if="modoItens">
            <div class="row row-space">
                <div class="form-item-data">
                    <label class="label-caption">Recebimento</label>
                    <input type="date" v-model="objEdicaoItem.dtrecebimento" />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Rota (Nº/Nome)</label>
                    <input type="text" v-model="objEdicaoItem.nmrota" maxlength="100" v-uppercase/>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Nro Apicultor</label>
                    <input type="text" class="input-right" v-model="edNroApicultor" v-number />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Coleta</label>
                    <input type="date" v-model="objEdicaoItem.dtcoleta" />
                </div>
                
                <div class="form-item-char20">
                    <label class="label-caption">Quantidade</label>
                    <input type="text" class="input-right" v-model="edQuantidade" v-decimal-mask />
                </div>
                
                <div class="form-item-char30">
                    <label class="label-caption">Lote</label>
                    <input type="text" class="input-center" v-model="objEdicaoItem.lote" maxlength="100" v-uppercase />
                </div>
            </div>



            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Florada Predominante</label>
                    <input type="text" v-model="objEdicaoItem.flpredominante" maxlength="100" v-uppercase />
                </div>    

                <div class="form-item-char20">
                    <label class="label-caption">Umidade</label>
                    <input type="text" class="input-right" v-model="edUmidade" v-decimal-mask />
                </div>
            </div>


            <div class="row-end">
                <button class="btn-confirm" @click="salvarItem">Salvar Ítem</button>
                <button class="btn-cancel" @click="abrirModal">Encerrar e Assinar</button>
                <button @click="closeForm">Sair</button>
            </div>            
        </div>
    </div>

    <div v-if="modoItens && lsItens.length > 0" class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th class="col-width-char10">Data</th>
                    <th>Rota</th>
                    <th class="col-width-char10">Coleta</th>
                    <th class="col-width-char15">Quantidade</th>
                    <th class="col-width-char15">Umidade</th>
                    <th class="col-width-char05"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsItens" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtrecebimento) }}</td>
                    <td>{{ obj.nmrota }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtcoleta) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.qtd) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.umidade) }}</td>
                    <td class="col-width-char05"><div class="row-left">
                        <button class="btn-icon btn-icon--trash" @click="excluiItem(obj)"></button>
                    </div></td>
                </tr>
            </tbody>
        </table>
    </div>

    <ConfirmModal ref="confirmModal" />

    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closeForm" 
        @confirmed="closeForm" />

    <SenhaModal ref="senhaModalRef" />
</template>
  
<script setup>
import { Api } from '@/funcoes/apiExport';
import { onMounted, ref } from 'vue';
import { criarAssinatura } from '@/models/assinatura';
import { criarPlaMel } from '@/models/plaMel';
import { criarPlaMelItem } from '@/models/plaMelItem';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const ckEmiteSalvo = ref(false);
const confirmModal = ref(null);
const edNroApicultor = ref(null);
const edQuantidade = ref(null);
const edUmidade = ref(null);
const isLoading = ref(false);
const lsItens = ref([]);
const modoItens = ref(false);
const msgAlerta = ref(null);
const msgOkModal = ref('Planilha encerrada e homologada com sucesso.');
const objAssinatura = ref(criarAssinatura());
const objEdicao = ref(criarPlaMel());
const objEdicaoItem = ref(criarPlaMelItem());
const showOkModal = ref(false);


async function abrirModal() {
    encerrarDigitacao();

    // const confirmado = await confirmModal.value.show({
    //     message: 'Deseja finalizar digitação e encaminhar documento para assinatura?',
    //     confirmText: 'Sim',
    //     cancelText: 'Não'
    // })

    // if (confirmado) {
    //     encerrarDigitacao();    
    // }
}


const closeForm = () => {
    if (ckEmiteSalvo.value) emit('save');
    emit('close'); 
}


async function encerrarDigitacao(){
    try{
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        isLoading.value=true;

        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:PLAMEL|IDREF:${objEdicao.value.id}|PROT:${objEdicao.value.protocolo}`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objEdicao.value.id;
        objAssinatura.value.doc_tipo = 'PLAMEL';

        const respAss = await Api.genericPut('/pla/plamel/homologar', objAssinatura.value);
        if (respAss.bolok === 1){
            ckEmiteSalvo.value=true;
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


const excluiItem = async(item) => {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma exclusão do ítem?',
        confirmText: 'Sim',
        cancelText: 'Não'
    });
    if (confirmado){
        try{
            msgAlerta.value=null;
            isLoading.value=true;
            await Api.genericDelete({id: item.id, strparam1: 'plamel_itens', idusuario: globalStore.idusuario});
            await lerItens();
        } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
        }finally{isLoading.value=false;}
    }
}


const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        let req=null;
        if (props.idEdicao==0){
            req = await Api.genericGet('/pla/plamel_new', {idestabelecimento: globalStore.idestabelecimento});
            Object.assign(objEdicao.value, req);
        }else{
            req = await Api.genericGet('/cad/plamel', {id: props.idEdicao});
            Object.assign(objEdicao.value, req[0]);
            modoItens.value=true;
            await lerItens();
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}


async function lerItens(){
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        const itens = await Api.genericPost('/lspla/plamel/itens', {id: objEdicao.value.id});
        lsItens.value = itens;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    // } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}


const salvarItem = async () => {
    msgAlerta.value = salvarItemDadosOk();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;

        objEdicaoItem.value.id = 0;
        objEdicaoItem.value.idplamel = objEdicao.value.id;
        objEdicaoItem.value.nroapicultor = Funcoes.integerFromString(edNroApicultor.value);
        objEdicaoItem.value.qtd = Funcoes.decimalFromString(edQuantidade.value);
        objEdicaoItem.value.umidade = Funcoes.decimalFromString(edUmidade.value);
        objEdicaoItem.value.idlogin = globalStore.idlogin;
        objEdicaoItem.value.idusuario = globalStore.idusuario;

        const response  = await Api.genericPut('/cad/plamel_item', objEdicaoItem.value);
        if (response.bolok === 1){
            ckEmiteSalvo.value=true;
            edQuantidade.value = null;
            lerItens();
        }else{
            msgAlerta.value=response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally{isLoading.value=false;}
}


function salvarItemDadosOk(){    
    let r = Validar.dataNoMes(objEdicaoItem.value.dtrecebimento, objEdicao.value.anomes);
    if (!r.ok) return `Data recebimento: ${r.msg}`;
    r = Validar.data(objEdicaoItem.value.dtcoleta, -1000);
    if (!r.ok) return `Data coleta: ${r.msg}`;
    r = Validar.numeroPositivo(edNroApicultor.value, 'Informe número de cadastro do apicultor');
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(edQuantidade.value, 'Informe a quantidade');
    if (!r.ok) return r.msg;
    return null;
}


const salvarCabecalho = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const response = await Api.genericPut('/cad/plamel', objEdicao.value);
        if (response.bolok === 1){
            if (objEdicao.value.id===0) objEdicao.value.id = response.id;
            ckEmiteSalvo.value=true;
            modoItens.value=true;
            await lerItens();
        }else{msgAlerta.value=`ATENÇÃO: ${response.erro}`;}
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


onMounted(lerDados)
</script>